var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "el-table",
      class: [
        {
          "el-table--fit": _vm.fit,
          "el-table--striped": _vm.stripe,
          "el-table--border": true,
          "el-table--scrollable-y": true,
          "el-table--enable-row-hover": true,
          "el-table--fluid-height": _vm.maxHeight,
        },
        _vm.tableSize ? `el-table--${_vm.tableSize}` : "",
      ],
      on: {
        mouseleave: function ($event) {
          return _vm.handleMouseLeave($event)
        },
      },
    },
    [
      _c(
        "div",
        { ref: "hiddenColumns", staticClass: "hidden-columns" },
        [_vm._t("default")],
        2
      ),
      _vm.showHeader
        ? _c(
            "div",
            { ref: "headerWrapper", staticClass: "el-table__header-wrapper" },
            [
              _c("table-header", {
                ref: "tableHeader",
                style: {
                  width: "100%",
                },
                attrs: {
                  store: _vm.store,
                  border: _vm.border,
                  "default-sort": _vm.defaultSort,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "bodyWrapper",
          staticClass: "el-table__body-wrapper",
          style: [_vm.bodyHeight],
        },
        [
          _c("table-body", {
            style: {
              width: _vm.bodyWidth,
            },
            attrs: {
              context: _vm.context,
              store: _vm.store,
              stripe: _vm.stripe,
              "row-class-name": _vm.rowClassName,
              "row-style": _vm.rowStyle,
              highlight: _vm.highlightCurrentRow,
              keeps: _vm.keeps,
            },
          }),
          !_vm.data || _vm.data.length === 0
            ? _c(
                "div",
                {
                  ref: "emptyBlock",
                  staticClass: "el-table__empty-block",
                  style: _vm.emptyBlockStyle,
                },
                [
                  _c(
                    "span",
                    { staticClass: "el-table__empty-text" },
                    [
                      _vm._t("empty", function () {
                        return [_vm._v(_vm._s(_vm.emptyText))]
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }